import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";


// --- Styles Interfaces and Objects ---
export interface ReturnHeaderMetaStyles {
    headerMetaWrapper?: InjectableCss;
}

export const ReturnHeaderMetaStyles: ReturnHeaderMetaStyles = {
    headerMetaWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 32px;
            margin-bottom: 16px;

            .order-no-wrapper {
                padding: 12px;
                border: 2px dashed ${themeColors.primary.richBlack};
                border-radius: 4px;
                display: flex;
                align-items: center;
                gap: 16px;

                @media only screen and (max-width: 767px) {
                    flex-direction: column;
                    align-items: flex-start;
                }

                .order-no-box {
                    display: flex;
                    align-items: center;
                    gap: 8px;

                    .meta-title {
                        color: ${themeBackgrounds.darkGray};
                    }
                }
            }
        `,
    },
};

const styles = ReturnHeaderMetaStyles;
const mapStateToProps = (state: ApplicationStateDana) => {
    return {
        order: state.standardReturnState?.selectedOrder,
    };
};
type Props = ReturnType<typeof mapStateToProps>;

// --- Component Definition ---
const ReturnHeaderMeta: FC<Props> = ({ order }) => {
    return (
        <StyledWrapper {...styles.headerMetaWrapper}>
            <StyledWrapper className="order-no-wrapper">
                <StyledWrapper className="order-no-box">
                    <Typography className="meta-title text-body-sm">{translate("Order Number:")}</Typography>
                    <Typography className="font-semibold text-body-sm">{order?.erpOrderNumber}</Typography>
                </StyledWrapper>
                <StyledWrapper className="order-no-box">
                    <Typography className="meta-title text-body-sm">{translate("Primary PO Number:")}</Typography>
                    <Typography className="font-semibold text-body-sm">{order?.primaryPoNumber}</Typography>
                </StyledWrapper>
                <StyledWrapper className="order-no-box">
                    <Typography className="meta-title text-body-sm">{translate("Secondary PO Number:")}</Typography>
                    <Typography className="font-semibold text-body-sm">{order?.secondaryPoNumber}</Typography>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};
export default connect(mapStateToProps)(ReturnHeaderMeta)

